module.exports = __webpack_public_path__ + "static/media/ownership-min.f3962f27.jpg";